<template>
  <div class="common-tab">
    <div class="common-tab__images">
      <template v-if="images.length > 0">
        <div v-for="(image, index) in images.slice(0, 3)" :key="index"
             class="image"
             role="button"
             :class="{'image--hidden': index > 2, [loadingClass]: index <= 2}"
        >
          <img
              :data-src="image"
              :src="image"
              @load="onLoadImage"
              @click="loadAndShowGallery(viewModel.hotelDescription.hotelId)"
              :alt="hotelName"
              loading="lazy"
          />
          <div v-show="index > 1"
               class="image__backdrop"
               @click="loadAndShowGallery(viewModel.hotelDescription.hotelId)">
            <div class="image__show-more" v-if="imagesCount > 0">+{{ $tc("photo", imagesCount) }}</div>
          </div>
        </div>
      </template>
      <div v-else class="common-tab__no-photo">
        <svg-icon icon="no-photo" :width="48" :height="48"/>
        <span class="common-tab__no-photo-text">
          {{ $res.Views.PackageSearch_NoHotelPhoto }}
        </span>
      </div>

      <template v-if="searchResultToHotelLoadingState === 'loading'">
        <div class="suggestion">
          <div>
            <Loader/>
          </div>
          <div class="search-result-loading">{{ $res.Views.HotelDetails_SearchOffersLoaderText }}</div>
        </div>
      </template>
      <template v-else>
        <div v-if="packageSearchResultItem && packageSearchResultItem.hasResult" class="suggestion">
          <div class="suggestion__inner">
            <div class="suggestion__title">
              {{ $res.Views.StayFrom_WithFlight_Date }}
            </div>
            <div class="suggestion__flight">
              <div class="suggestion__from">{{ packageSearchResultItem.departureLocation }}</div>
              <svg-icon icon="arrow-right"/>
              <div class="suggestion__to">{{ packageSearchResultItem.destinationLocation }}</div>
            </div>
            <div class="suggestion__date">
              {{ packageSearchResultItemPeriod }}
            </div>
            <div class="suggestion__people" v-html="packageSearchResultItemTourists"></div>
          </div>
          <div class="suggestion__book">
            <base-button variant="outline" size="max" @click="onClickGoToSearchResultItemHandler">
              {{ packageSearchResultItemPrice }}
            </base-button>
          </div>
        </div>
        <div v-else class="suggestion">
          <span class="suggestion__tour-search">{{ $res.Views.HotelDescription_ShowToursText }}</span>
          <base-button variant="outline" size="max" @click="onClickGoToPackageSearchPageHandler">
            {{ $res.Views.BookingCreation_Continue }}
          </base-button>
        </div>
      </template>
      
      
    </div>

    <HotelOptions v-if="!!options.length" :options="options"/>

    <div class="common-tab__content">
      <div class="common-tab__left-side">
        <div class="common-tab__description" v-html="hotelDescription"></div>
        <div class="common-tab__checkin">
          <div class="common-tab__checkin-item" v-if="viewModel.hotelDescription.checkIn">
            <SvgIcon icon="straight-arrows/right" class="text-status-available-10"/>
            <span>{{ $res.Views.CheckIn }} - </span>
            <span v-html="viewModel.hotelDescription.checkIn"></span>
          </div>
          <div class="common-tab__checkin-item" v-if="viewModel.hotelDescription.checkOut">
            <SvgIcon icon="straight-arrows/left" class="text-main-10"/>
            <span>{{ $res.Views.CheckOut }} - </span>
            <span v-html="viewModel.hotelDescription.checkOut"></span>
          </div>
        </div>
        <div class="common-tab__accomodation-features"  v-if="showAccommodationBlock">
          <div class="common-tab__accomodation-features-header headings-font-family">
            {{ $res.Views.Accomodation }}
          </div>
          <div class="common-tab__accomodation-feature-list">
            <ul class="accomodation-feature-list">
              <li class="accomodation-feature-list__item"
                  v-if="viewModel.hotelDescription.singleManAccommodationAllowed || viewModel.hotelDescription.singleManAccommodationAllowed === false"
              >
                <span class="accomodation-feature-list__item-text">{{ $res.Views.SinglesAllowed }}:</span>
                <span class="accomodation-feature-list__item-value">{{
                    viewModel.hotelDescription.singleManAccommodationAllowed ? $res.General.Yes : $res.General.No
                  }}</span>
              </li>
              <!--              <li class="accomodation-feature-list__item" v-if="placement && placement.age_restriction">-->
              <!--                <span class="accomodation-feature-list__item-text">{{ $res.Views.Accomodation_AgeRestriction }}:</span>-->
              <!--                <span class="accomodation-feature-list__item-value" v-html="placement.age_restriction"></span>-->
              <!--              </li>-->
              <li class="accomodation-feature-list__item"
                  v-if="viewModel.hotelDescription.animalsAllowed || viewModel.hotelDescription.animalsAllowed === false"
              >
                <span class="accomodation-feature-list__item-text">{{ $res.Views.Accomodation_WithPets }}:</span>
                <span class="accomodation-feature-list__item-value">
                  {{ viewModel.hotelDescription.animalsAllowed ? $res.General.Yes : $res.General.No }}
                </span>
              </li>
              <li class="accomodation-feature-list__item"
                  v-if="viewModel.hotelDescription.disabledPeopleAccommodationProvided || viewModel.hotelDescription.disabledPeopleAccommodationProvided === false"
              >
                <span class="accomodation-feature-list__item-text">{{ $res.Views.Accomodation_DisabledRooms }}:</span>
                <span class="accomodation-feature-list__item-value">
                  {{
                    viewModel.hotelDescription.disabledPeopleAccommodationProvided ? $res.General.Yes : $res.General.No
                  }}
                </span>
              </li>
              <!--              <li class="accomodation-feature-list__item" v-if="placement && placement.connection_rooms">-->
              <!--                <span class="accomodation-feature-list__item-text">{{ $res.Views.Accomodation_SplitRooms }}:</span>-->
              <!--                <span class="accomodation-feature-list__item-value" v-html="placement.connection_rooms"></span>-->
              <!--              </li>-->
              <li class="accomodation-feature-list__item"
                  v-if="viewModel.hotelDescription.smokingAllowed || viewModel.hotelDescription.smokingAllowed === false"
              >
                <span class="accomodation-feature-list__item-text">{{ $res.Views.NoSmokingRooms }}:</span>
                <span class="accomodation-feature-list__item-value">
                  {{ viewModel.hotelDescription.smokingAllowed ? $res.General.No : $res.General.Yes }}
                </span>
              </li>
              <!--              <li class="accomodation-feature-list__item" v-if="placement && placement.guest_zoo_comment">-->
              <!--                <span class="accomodation-feature-list__item-text">{{ $res.Views.Common_AccommodationRemarks }}:</span>-->
              <!--                <span class="accomodation-feature-list__item-value" v-html="placement.guest_zoo_comment"></span>-->
              <!--              </li>-->
            </ul>
          </div>
        </div>
      </div>


      <div v-if="showHotelDescriptionBlock || files.length > 0" class="common-tab__right-side">
        <div v-if="showHotelDescriptionBlock" class="block">
          <div class="block__row" v-if="viewModel.hotelDescription.numberOfRooms">
            <div class="block__text">{{ $res.Views.RoomsCount }}</div>
            <div class="block__value">{{ viewModel.hotelDescription.numberOfRooms }}</div>
          </div>
          <div class="block__row" v-if="viewModel.hotelDescription.constructionYear">
            <div class="block__text">{{ $res.Views.BuildDate }}</div>
            <div class="block__value">{{ viewModel.hotelDescription.constructionYear }}</div>
          </div>
          <div class="block__row" v-if="viewModel.hotelDescription.lastRenovationYear">
            <div class="block__text">{{ $res.Views.RenovateDate }}</div>
            <div class="block__value">{{ viewModel.hotelDescription.lastRenovationYear }}</div>
          </div>
          <div class="block__row" v-if="viewModel.hotelDescription.totalAreaInSquareMeters">
            <div class="block__text">{{ $res.Views.TotalArea }}</div>
            <div class="block__value">
              {{ $fmt($res.General.SquareMetersArea, viewModel.hotelDescription.totalAreaInSquareMeters) }}
            </div>
          </div>
          <div class="block__row" v-if="viewModel.hotelDescription.numberOfBuildings">
            <div class="block__text">{{ $res.Views.BuildingCount }}</div>
            <div class="block__value">{{ viewModel.hotelDescription.numberOfBuildings }}</div>
          </div>
        </div>
        <div class="block" v-if="files.length">
          <div class="bold">
            {{ $res.Views.AdditionalInformation }}
          </div>
          <a v-for="(file, index) in files" :key="index"
             :href="file.url"
             class="block__text file"
             target="_blank"
             download
             role="button"
          >
            <svg-icon :icon="file.iconName"/>
            {{ file.description }}
          </a>
        </div>
      </div>
    </div>
    <ExpandablePanel v-if="viewModel.hotelDescription.remarks?.length > 0" class="common-tab__remarks"
                     :is-opened="true">
      <template #title>{{ $res.Views.HotelDescription_Remarks }}</template>
      <template #default>
        <div v-for="remark in viewModel.hotelDescription.remarks" class="remark">
          <div class="remark__title">{{ remark.title }}</div>
          <div class="remark__text" v-html="remark.text"></div>
        </div>
      </template>
    </ExpandablePanel>
    <modal-dialog dialog-class="modal-dialog_suggestion" v-model="goToB2CSuggestionDialogShown">
      <template v-slot:header>
        <modal-header :title="$res.Views.AgencyWebsiteBanner_Dialog_Title"></modal-header>
      </template>
      <template v-slot:content>
        <div class="modal-dialog_suggestion-content">
          {{ $res.Views.AgencyWebsiteBanner_Dialog_Text }}
        </div>
      </template>
      <template v-slot:footer>
        <DefaultFooter
            :closeBtnText="$res.Views.AgencyWebsiteBanner_ButtonTourists"
            @closed="onCloseClickedNotificationHandler"
            :actionBtnText="$res.Views.AgencyWebsiteBanner_ButtonAgency"
            @action-clicked="onActionClickedNotificationHandler"
        />
      </template>
    </modal-dialog>
  </div>
</template>

<script>
import {post} from "@/common/fetch";
import BaseButton from "@/common/controls/BaseButton.vue";
import HotelOptions from "../hotelOptions/HotelOptionsComponent.vue";
import SvgIcon from "@/common/controls/SvgIconControl.vue";
import {HotelDetailsHelper} from "../helpers";
import ImageLoaderMixin from "../imageLoader/ImageLoaderMixin";
import DefaultFooter from "@/common/modal/DataDialogDefaultFooterComponentDesktop.vue";
import ModalHeader from "@/common/modal/DataDialogDefaultHeaderComponentDesktop.vue";
import ModalDialog from "@/common/modal/DataDialogComponentDesktopBase.vue";
import HotelGalleryMixin from "@/common/hotelGallery/HotelGalleryMixin";
import ExpandablePanel from "@/common/ExpandablePanel.vue";
import YmEventsSender from "@/util/ymEventsSender";
import Loader from "@/common/Loader2.vue";
import {SearchResultToHotelMixin} from "./SearchResultsToHotelMixin";

export default {
  mixins: [
    ImageLoaderMixin,
    HotelGalleryMixin,
    SearchResultToHotelMixin
  ],
  components: {
    SvgIcon,
    BaseButton,
    ModalHeader,
    ModalDialog,
    HotelOptions,
    DefaultFooter,
    ExpandablePanel,
    Loader,
  },
  props: {
    viewModel: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      goToB2CSuggestionDialogShown: false,
      searchUrl: ''
    }
  },
  created() {
    this.loadSearchResultToHotel(this.viewModel.hotelId, this.viewModel.destinationCountryId, this.viewModel.hotelDescription.internalHotelId);
  },
  mounted() {
    const descriptionBlock = this.$el.querySelector(".common-tab__description");
    descriptionBlock.querySelectorAll("a").forEach(a => {
      const t = a.getAttribute("target");
      if(!t) {
        a.setAttribute("target", "_blank");
        a.setAttribute("rel", "noopener");
      }
    });
  },
  computed: {
    options() {
      return this.viewModel.hotelDescription.hotelAttributes;
    },
    imagesCount() {
      return this.viewModel.hotelDescription.images.length - 3;
    },
    images() {
      return this.viewModel.hotelDescription.images.map(item => item.url);
    },
    hotelDescription() {
      return this.viewModel.hotelDescription.overviewText;
    },
    hotelName() {
      return this.viewModel.hotelDescription.hotelName;
    },
    placement() {
      return null; // нет в ответе
      return this.viewModel.hotelDescription.placementService.placement;
    },
    files() {
      return this.viewModel.hotelDescription.files.map(item => {
        return {
          description: item.name,
          url: item.url,
          iconName: HotelDetailsHelper.getFileIconName(item.type)
        };
      });
    },
    packageSearchResultItem() {
      return this.searchResultToHotel;
    },
    packageSearchResultItemPeriod() {
      return `${this.$res.General.From_Future} ${this.$formatDateShortDDMM(this.packageSearchResultItem.startDate)} ${this.$res.General.Until_Date} ${this.$formatDateShortDDMM(this.packageSearchResultItem.endDate)}`;
    },
    packageSearchResultItemPrice() {
      return `${this.$res.General.From_Date} ${this.$formatPrice0(this.packageSearchResultItem.bookingPrice)} ${this.packageSearchResultItem.currency}`;
    },
    packageSearchResultItemTourists() {
      const adultCount = this.packageSearchResultItem.adultCount;
      const childCount = this.packageSearchResultItem.childCount;
      const infantCount = this.packageSearchResultItem.infantCount;
      const duration = this.packageSearchResultItem.duration;
      const g = this.$res.General;
      const result = [];

      if (adultCount) {
        result.push(`${adultCount}&nbsp;${g.Adult_Abbreviation}`);
      }

      if (childCount) {
        result.push(`${childCount}&nbsp;${g.Child_Abbreviation}`);
      }

      if (infantCount) {
        result.push(`${infantCount}&nbsp;${g.Infant_Abbreviation}`);
      }

      return `${this.$tc('night', duration)}, ${result.join("&nbsp;+ ")}`;
    },
    showHotelDescriptionBlock() {
      return this.viewModel.hotelDescription.numberOfRooms ||
          this.viewModel.hotelDescription.lastRenovationYear ||
          this.viewModel.hotelDescription.lastRenovationYear ||
          this.viewModel.hotelDescription.totalAreaInSquareMeters ||
          this.viewModel.hotelDescription.numberOfBuildings;          
    },
    showAccommodationBlock() {
      return this.viewModel.hotelDescription.singleManAccommodationAllowed || 
          this.viewModel.hotelDescription.singleManAccommodationAllowed === false ||
          this.viewModel.hotelDescription.animalsAllowed || 
          this.viewModel.hotelDescription.animalsAllowed === false ||
          this.viewModel.hotelDescription.disabledPeopleAccommodationProvided || 
          this.viewModel.hotelDescription.disabledPeopleAccommodationProvided === false ||
          this.viewModel.hotelDescription.smokingAllowed || 
          this.viewModel.hotelDescription.smokingAllowed === false ||
          this.viewModel.hotelDescription.checkIn ||
          this.viewModel.hotelDescription.checkOut
    },
  },
  methods: {
    onActionClickedNotificationHandler() {
      YmEventsSender.sendHotelDescriptionContinueAsAgencyFromPopup();
      post("/HotelDescription/ContinueAsAgent").then(() => {
        window.location.href = this.searchUrl;
      });
    },
    onCloseClickedNotificationHandler() {
      YmEventsSender.sendHotelDescriptionRedirectToB2cFromPopup();
      window.location.href = this.viewModel.packageSearchResultItem.b2CUrl;
    },
    onClickGoToSearchResultItemHandler() {
      const search = this.packageSearchResultItem.encryptedSearchParameters;
      const targetUrl = `${this.packageSearchResultItem.packageSearchUrl}?search=${search}`;

      if (!window.layoutModel.goToB2CSuggestion.showSuggestion) {
        window.location.href = targetUrl;
      } else {
        this.goToB2CSuggestionDialogShown = true;
        this.searchUrl = targetUrl;
      }
    },
    onClickGoToPackageSearchPageHandler() {
      if (!window.layoutModel.goToB2CSuggestion.showSuggestion) {
        window.location.href = "/packageSearch";
      } else {
        this.searchUrl = "/packageSearch";
        this.goToB2CSuggestionDialogShown = true;
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.common-tab {
  &__images {
    display: flex;
    gap: 4px;
    margin-bottom: 20px;
    border-radius: var(--border-radius-md);
    overflow: hidden;
    height: 200px;

    .image {
      position: relative;
      height: 200px;
      flex: 1 1 25%;
      max-width: 266px;
      overflow: hidden;

      &--hidden {
        display: none;
      }

      img {
        width: 100%;
        height: 200px;
        object-fit: cover;
      }

      &__backdrop {
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
        background: rgba(35, 35, 35, 0.35);
      }

      &__show-more {
        padding: 2px 8px;
        background: #FFFFFF;
        border-radius: var(--border-radius-sm);
        font-size: 11px;
        line-height: 16px;
        color: var(--second-10);
        cursor: pointer;
      }
    }
  }

  &__description {
    :deep(ul) {
      margin: 0;
      padding: 0;
      list-style: none;
      display: flex;
      flex-direction: column;
      gap: 4px;

      li:before {
        content: "";
        background-color: currentColor;
        margin-right: 9px;
        display: inline-block;
        width: 6px;
        height: 6px;
        border-radius: 6px;
        position: relative;
        top: -1px;
      }

      li {
        line-height: 20px;
        
        > ul {
          padding-inline-start: 16px;
        }
      }
      
      + p {
        margin-top: 1rem;
      }
    }

    :deep(p:last-child) {
      margin-block-end: unset;
    }
    
    :deep(hr) {
      border-top: 3px solid var(--main-40);
    }
  }

  &__content {
    display: flex;
    margin-top: 20px;
  }

  &__left-side {
    flex: 1;
    margin-right: 16px;
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  &__right-side {
    width: 334px;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  &__checkin {
    display: flex;
    flex-flow: row wrap;
    gap: 10px 16px;
  }

  &__checkin-item {
    padding: 2px 8px;
    display: flex;
    gap: 4px;

    font-size: 11px;
    line-height: 16px;

    border-radius: var(--border-radius-sm);
    background: var(--main-40);

    > svg {
      flex: 0 0 auto;
    }
  }

  &__accomodation-features {
  }

  &__accomodation-features-header {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 16px;
  }

  &__accomodation-features-list {
    list-style: none;
  }
}

.common-tab__no-photo {
  background-color: var(--main-50);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: var(--second-20);
  width: 100%;

  svg {
    color: var(--main-30);
  }
}

.block {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px 24px;
  background: var(--main-50);
  border-radius: var(--border-radius-md);

  &__row {
    display: flex;
    justify-content: space-between;
  }

  &__value,
  &__title {
    width: 100px;
    font-weight: 600;
  }

  &__text {
    line-height: 20px;
  }
}

.accomodation-feature-list {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.accomodation-feature-list__item {
  display: flex;
  align-items: flex-start;
  gap: 4px;
  font-weight: 400;
  font-size: 13px;
  line-height: 20px;
  
  &:before {
    content: "";
    flex: 0 0 auto;
    width: 12px;
    height: 12px;
    transform: scale(0.5);
    position: relative;
    top: 4px;
    border-radius: 50%;
    background-color: currentColor;
  }
}

.accomodation-feature-list__item-value {
  font-weight: 600;
}


.suggestion {
  background: var(--main-50);
  height: 200px;
  width: 267px;
  padding: 16px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 15px;
  border-radius: 0 var(--border-radius-md) var(--border-radius-md) 0;

  &__tour-search {
    color: var(--second-20);
    text-align: center;
  }

  &__inner {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 5px;
  }

  &__flight {
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: 600;
  }

  &__people {
    color: var(--second-20);
  }

  &__book,
  button {
    width: 100%;
  }
}

.search-result-loading {
  color: var(--second-20);
}

.file {
  display: flex;
  gap: 8px;
  align-items: start;
  
  svg {
    flex-shrink: 0;
    margin-top: 2px;
  }  
}

.common-tab__no-photo-text {
  margin-top: 10px;
}

.common-tab__remarks {
  margin-top: 20px;
  cursor: pointer;

  :deep(.expandable-panel__content) {
    padding: 20px 0;
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  :deep(ul) {
    padding-left: 24px;
  }
}

.remark__title {
  font-weight: 600;
  margin-bottom: 10px;
}

.remark {
  .remark__text:first-letter {
    text-transform: capitalize;
  }
  
  :deep(.remark__text *:last-child) {
    margin-bottom: 0;
  }
}

.text-status-available-10 {
  color: var(--status-available-10);
}
</style>

<style lang="scss">
.modal.modal_data-dialog .modal-dialog.modal-dialog_suggestion {
  .modal-content {
    min-height: 0 !important;
  }

  .modal-body__postcontent {
    padding: 0;
  }

  .modal-dialog_suggestion-content {
    padding: 10px 24px 20px 24px;
  }

  .modal-footer_border {
    border-top: 2px solid var(--main-50);
  }
}
</style>